import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material"
import PropTypes from 'prop-types'
import React , {useState, useEffect} from "react"
import DatalakeService from "src/services/datalake-service"


const TabelaBalanco = ({ tipoBalanco,raiz_cnpj }) => {
    const [data, setData] = useState([])
    const calcService = new DatalakeService()

    useEffect(() => {
        loadData()
    },[tipoBalanco,raiz_cnpj])

    const loadData = () => {
        calcService.getIndicesBalanco(raiz_cnpj, tipoBalanco).then((response) => {
            const { body } = response
            const { data } = body
            
            const list = data.map((obj, index) => {
                const formattedAtivoTotal = Number(obj.AtivoTotal)
                    .toFixed(2) 
                    .replace(/\./g, ',') 
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                // Verifica se a Ordem Grandeza é 'R$' para definir a posição correta
                const ativoFinal = obj.OrdemGrandezaAtivo === 'R$'
                    ? `R$ ${formattedAtivoTotal}` 
                    : `${formattedAtivoTotal} ${obj.OrdemGrandezaAtivo}` 
            
                return {
                    id: index,
                    DataReferencia: obj.DataReferencia.replace(/-/g, '/'), 
                    AtivoTotal: ativoFinal,
                }
            })

            setData(list)
        })
        .catch((error) => {
            
            console.error("Erro ao buscar dados:", error)
            setData([])
        })
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>R$MM</TableCell>
                        {data.map((item, index) => (
                            <TableCell key={index} align="right">{item.DataReferencia}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Ativo Total</TableCell>
                        {data.map((item, index) => (
                            <TableCell key={index} align="right">{item.AtivoTotal}</TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

TabelaBalanco.propTypes = {
    raiz_cnpj: PropTypes.string,
    tipoBalanco: PropTypes.string,
}

export default TabelaBalanco
